import { Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import List from "./list components/List";
import { useAxios } from "../../hooks";
import { PageHeader, Pagination } from "../../components";
import { PrimaryButton } from "../css components/Button";
import { useNavigate } from "react-router-dom";

export default function CustomFieldList() {
  const axios = useAxios();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [page, setPage] = useState({ page: 1, totalCount: 0, lastCount: 0 });

  useEffect(() => {
    setLoading(true);
    axios({
      url:
        "/custom-field-list?page=" +
        page.page +
        "&limit=10" +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : ""),
      method: "GET",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setCustomFields(response.data.fields);
        setPage((prev) => ({
          ...prev,
          totalCount: response.data.totalCount,
          lastPage: response.data?.fields?.length < 10,
        }));
      }
      setLoading(false);
    });
  }, [searchKey, axios, page.page]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"Audience Custom Fields"}
            pageHeader="List of Audience Custom Fields"
            icons={[
              <PrimaryButton
                variant="contained"
                onClick={() => navigate(pages.customFieldsCreatePage.route)}
              >
                Create Audience Custom Field
              </PrimaryButton>,
            ]}
          />
        </Grid>
      </Grid>

      <List
        customFields={customFields}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            style={{ marginTop: "20px" }}
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
